import { freezeOrganizationInviteOnRedirect } from '../components/OrganizationInviteCapture';
import { assertNoRedirectLoop } from './redirectLoopDetector';

export type IdSiteRedirectPurpose = 'LOGIN' | 'ONBOARDING';

export const exhaust = (type: never): never => {
  throw new Error(`unknown id site redirect purpose ${type}`);
};

/**
 * Redirect to ID site via window.location for a given purpose. Can be either login or missing onboarding.
 * @param returnToUrl this url is passed to ID site, which then redirects back to this when it has done it's thing.
 * @param purpose the reason we're going to the id site
 */
export const redirectToIdSite = (returnToUrl: string, purpose: IdSiteRedirectPurpose) => {
  let path: string;

  switch (purpose) {
    case 'LOGIN':
      assertNoRedirectLoop('id site login');
      // robocloud login
      path = 'robocloud';
      break;
    case 'ONBOARDING':
      assertNoRedirectLoop('id site onboarding');
      // root
      path = '';
      break;
    default:
      path = '';
      exhaust(purpose);
  }
  freezeOrganizationInviteOnRedirect();
  window.location.replace(`${import.meta.env.VITE_ID_URL}/${path}?redirect=${btoa(returnToUrl)}`);
};
